<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="contacts-side-panel">
    <SmsContactList />
  </div>
</template>

<script>
import SmsContactList from '@/components/SmsContactList/SmsContactList';

export default {
  name: 'SmsContactSidePanel',

  components: {
    SmsContactList
  }
};
</script>

<style scoped>
.contacts-side-panel {
  height: 100%;
  background: var(--v-surface-base);
}
</style>
